import React from 'react';
import { useRecoilState } from 'recoil';

//import { Formik, Form, Field } from 'formik';
import { Box } from '@mui/material';

import stateResultMode from '../state/stateResultMode';

import useBeaconFilters from './beacon-page/useBeaconFilters';
import useBeaconImagenFilters from './beacon-page/useBeaconImagenFilters';

import ResultsViewSelector from './beacon-page/results/ResultsViewSelector';
import ResultViewGenomic from './beacon-page/results/ResultViewGenomic';
import ResultViewClinical from './beacon-page/results/ResultViewClinical';
import ResultViewRadiomics from './beacon-page/results/ResultViewRadiomics';

import QueryForm from './beacon-page/query-form/QueryForm';

export default function SearchPage() {
  const [resultMode] = useRecoilState(stateResultMode);
  useBeaconFilters();
  useBeaconImagenFilters();
  return (
    <Box padding={2}>
      <Box display="flex" flexDirection="row">
        <Box flexGrow={1} />
        <Box flexGrow={0} width="80em" textAlign="left">
          <QueryForm />
          <Box height="1em" />
          <ResultsViewSelector />
          <div>
            {'genomic' === resultMode && <ResultViewGenomic />}
            {'clinical' === resultMode && <ResultViewClinical />}
            {'radiomics' === resultMode && <ResultViewRadiomics />}
          </div>
        </Box>
        <Box flexGrow={1} />
      </Box>
    </Box>
  );
}
